import { doc, onSnapshot, type Unsubscribe } from 'firebase/firestore'
import { firestoreDb } from './firebase'
import { normalizeMaintenanceMode } from './ownerConsoleSettingsModel'

export type MaintenanceModeState = { enabled: boolean; message: string }

/** Maps a raw `system/config` document to the maintenance state shown in the apps. */
export const mapMaintenanceModeSnapshot = (data: unknown): MaintenanceModeState => {
  const record = data && typeof data === 'object' ? (data as Record<string, unknown>) : {}
  return normalizeMaintenanceMode(record.maintenanceMode)
}

/**
 * Live `system/config.maintenanceMode` (readable by any signed-in user,
 * firestore.rules `system/config`). Callers subscribe only when signed in.
 */
export const subscribeToMaintenanceMode = (
  callback: (state: MaintenanceModeState) => void,
  onError?: (error: Error) => void,
): Unsubscribe =>
  onSnapshot(
    doc(firestoreDb, 'system', 'config'),
    (snapshot) => callback(mapMaintenanceModeSnapshot(snapshot.data())),
    (error) => onError?.(error),
  )
